import { render, staticRenderFns } from "./PackageContentList.vue?vue&type=template&id=69a6a36c"
import script from "./PackageContentList.vue?vue&type=script&lang=js"
export * from "./PackageContentList.vue?vue&type=script&lang=js"
import style0 from "./PackageContentList.vue?vue&type=style&index=0&id=69a6a36c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports